import { render, staticRenderFns } from "./CPrice.vue?vue&type=template&id=49cbd682&"
import script from "./CPrice.vue?vue&type=script&lang=ts&"
export * from "./CPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports